import $ from 'jquery';
import ScrollMagic from "scrollmagic";

function init() {
  collectionsNav();
  scrollProgressBar();
}

function collectionsNav() {
  $('.collectionsNav-dropdownItem a').not('[href="#"]').on('click', function(event) {
    event.preventDefault()
    const selectedCat = $(this).text()
    $('.collectionsNav-selected').text(selectedCat)
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      let target = $(this.hash)
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')

      if (target.length) {
        const offset = $('.header').outerHeight() + 80
        const scroll = target.offset().top - offset
        $('html, body').animate({
          scrollTop: scroll
        }, 1000, function() {
          var $target = $(target)
          $target.focus({ preventScroll: true })
          if ($target.is(":focus")) {
            return false
          } else {
            $target.attr('tabindex', '-1')
            $target.focus({ preventScroll: true })
          }
        })
      }
    }
  })
}

function scrollProgressBar() {
  const controller = new ScrollMagic.Controller({
    globalSceneOptions: {}
  });
    
  $('.collection').each(function() {
    const id = $(this).attr('id');
    const url = $(`a[href="#${id}"]`).parent().attr("id");

    new ScrollMagic.Scene({
      triggerElement: `#${id}`,
      duration: function(){
        return $(`#${id}`).height();
      }
    })
      .setClassToggle(`#${url}`, "active")
      // .on("enter", function(){})
      .addTo(controller);
  })
}

$(function(){
  init()
});
